import RootStore from './Store';
import RootStoreContext from './Context';

/**
 * This is a Singleton to ensure we have the same instance of the RootStore across the App
 * since we're using the RootStoreProvider for each module when necessary to improve performance
 */
const rootStore = new RootStore();

/**
 * @deprecated This provider should not be used for new development
 */
export default function RootStoreProvider(props: Record<string, any>) {
    return <RootStoreContext.Provider value={rootStore} {...props} />;
}
